"use strict";
import { useContext, useMemo } from "react";
import { useLocation } from "react-router";
import { getModuleMetadata } from "../api";
import { ShellContext } from "../context";
import { useModules, usePermissionCheck } from "../hooks";
import { PAGE_AGENT_CHAT_OPT_IN_KEY, useAgentChatPageContext } from "./AgentChatContext";
const REQUIRED_PERMISSIONS = ["ai_streaming:jarvis_send_message"];
const ENABLED_HOSTNAME_FRAGMENTS = ["staging", "uat", "qa", "demo", "localhost", "10.211.55.3"];
const NO_PERMISSIONS = [];
export const useAgentChatBaseUrl = () => {
  return useMemo(() => {
    var _a;
    const template = typeof site === "undefined" ? "" : (_a = site.aiStreamingBaseUrl) != null ? _a : "";
    return template.replace("{{protocol}}", window.location.protocol).replace("{{hostname}}", window.location.hostname);
  }, []);
};
const useActiveModuleId = () => {
  const { moduleRootPath } = useContext(ShellContext);
  const modules = useModules();
  const { pathname } = useLocation();
  return useMemo(() => {
    const rootPath = moduleRootPath === "/" ? "" : moduleRootPath;
    for (const module of modules) {
      const modulePath = `${rootPath}/${module.info.id}`;
      if (pathname === modulePath || pathname.startsWith(`${modulePath}/`)) return module.info.id;
    }
    return null;
  }, [moduleRootPath, modules, pathname]);
};
export const useIsAgentChatEnabled = () => {
  var _a, _b;
  const activeModuleId = useActiveModuleId();
  const baseUrl = useAgentChatBaseUrl();
  const agentChat = activeModuleId ? (_b = (_a = getModuleMetadata(activeModuleId)) == null ? void 0 : _a.features) == null ? void 0 : _b.agentChat : void 0;
  const isModuleEnabled = (agentChat == null ? void 0 : agentChat.enabled) === true;
  const isModuleOptedOut = (agentChat == null ? void 0 : agentChat.enabled) === false;
  const pageContext = useAgentChatPageContext();
  const isPageEnabled = !isModuleOptedOut && pageContext[PAGE_AGENT_CHAT_OPT_IN_KEY] === true;
  const requiredPermissions = useMemo(
    () => {
      var _a2;
      return [...REQUIRED_PERMISSIONS, ...(_a2 = agentChat == null ? void 0 : agentChat.permissions) != null ? _a2 : NO_PERMISSIONS];
    },
    [agentChat]
  );
  const hasRequiredPermissions = usePermissionCheck(requiredPermissions);
  const isDocumentationChatbotDemoPage = window.location.pathname.includes("/module/documentation/agent-chatbot");
  if (isDocumentationChatbotDemoPage) {
    return false;
  }
  const isEnabledHostname = ENABLED_HOSTNAME_FRAGMENTS.some(
    (fragment) => window.location.host.includes(fragment)
  );
  return (isModuleEnabled || isPageEnabled) && hasRequiredPermissions && isEnabledHostname && Boolean(baseUrl);
};
